import { Result } from "antd";
import { FormattedMessage } from "react-intl";

const NoRoles = () => (
  <Result
    status="403"
    title={
      <FormattedMessage
        id="messages.accessDenied"
        defaultMessage="Přístup odepřen"
      />
    }
    subTitle={
      <FormattedMessage
        id="messages.accessDenied.message"
        defaultMessage="K této webové aplikace nemáte přístup. Pokud si myslíte, že byste ho měl mít, kontaktujte DHL ITS."
      />
    }
  />
);

export default NoRoles;
